'use client';
import NotificationPreferences from './components/NotificationPreferences';

export default function NotificationPreferencesPage() {
  return <NotificationPreferences />;
}
